import React from "react";
import { useUscLabel } from "../../../../../utils/labels";
import Button from "../../../../../../shared-components/toyota/styles/atoms/Button";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import useUscFinanceCalculatorButton from "../../../../../hooks/useUscFinanceCalculatorButton";
import type { UscTrackingLocation } from "../../../../../utils/tracking";

/**
 * In the first phase of the PDP rework the finance options button will still open the finance calculator
 * In the second phase this button will link to the finance in page
 */
const UscFinanceOptionsButton = ({ trackingLocation }: { trackingLocation: UscTrackingLocation }): JSX.Element => {
    const buttonLabel = useUscLabel("uscBasketCtaFinanceOptions");
    const { isDisabled, showCalculator } = useUscFinanceCalculatorButton(trackingLocation);

    return (
        <Button variant="basket-cta" onClick={showCalculator} disabled={isDisabled}>
            <Icon variant="financing" />
            {buttonLabel}
        </Button>
    );
};

export default UscFinanceOptionsButton;
